import OrderCommentsIcon from './OrderCommentsIcon';

export default OrderCommentsIcon;
